var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTextbox',{attrs:{"label":"Token","value":"123456789","readonly":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }